import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';
import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Headline, Description } from 'autogen/translation-keys/trans-website-contentful-genericcontentfulerrorpage';
import { GoToHomePage } from 'autogen/translation-keys/trans-website-shared';
import LinkActionButton from 'components/Button/LinkActionButton';
import styled from 'styled-components';

const StyledLinkActionButton = styled(LinkActionButton)`
    width: fit-content;
`;

function GenericContentfulErrorPage() {
    const { t } = useTranslation();

    return (
        <Layout.Page>
            <Layout.Section>
                <Typography.Headline size="L" as="h1">
                    {t(Headline)}
                </Typography.Headline>
                <Typography.Body>{t(Description)}</Typography.Body>
                <StyledLinkActionButton
                    action={{
                        $type: 'PlainLinkAction',
                        url: '/',
                        openInNewWindow: false,
                        noFollow: false
                    }}
                >
                    {t(GoToHomePage)}
                </StyledLinkActionButton>
            </Layout.Section>
        </Layout.Page>
    );
}

export default withErrorBoundary(GenericContentfulErrorPage, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
